import * as THREE from "three";
export function getRandomUnitVector() {
    let x = 0;
    let y = 0;
    let z = 0;
    let w = 0;
    let d = 0;
    while (d < 1e-2) {
        x = Math.random() * 2 - 1;
        y = Math.random() * 2 - 1;
        z = Math.random() * 2 - 1;
        w = Math.random() * 2 - 1;
        d = x * x + y * y + z * z + w * w;
    }
    d = Math.sqrt(d);
    return new THREE.Vector4(x / d, y / d, z / d, w / d);
}
export function getRandomUnitVector3() {
    let x = 0;
    let y = 0;
    let z = 0;
    let d = 0;
    while (d < 1e-2) {
        x = Math.random() * 2 - 1;
        y = Math.random() * 2 - 1;
        z = Math.random() * 2 - 1;
        d = x * x + y * y + z * z;
    }
    d = Math.sqrt(d);
    return new THREE.Vector3(x / d, y / d, z / d);
}
export function isTheSamePoint(a, b) {
    const u = new THREE.Vector4().copy(a);
    const v = new THREE.Vector4().copy(b);
    const d = u.dot(v);
    if (d < 0) {
        return false;
    }
    return 1 - d / (u.length() * v.length()) < 1e-6;
}
export function isTheSameLine(k, l) {
    const d = k.dot(l);
    if (d < 0) {
        return false;
    }
    return 1 - d / (k.norm * l.norm) < 1e-6;
}
export function getRandomPlaneThroughOrigin(origin) {
    const normal = getRandomUnitVector3();
    return [normal.x, normal.y, normal.z, -normal.dot(origin)];
}
//# sourceMappingURL=utils.js.map